import React from "react";
import "../styles/Input.css";

const Input = ({ label, amount, className, currency = "BTC", type, ...props }) => {
  const handleInput = (e) => {
    // Allow only one decimal point
    if (type && type==="number"){
      const value = e.target.value;
      e.target.value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\./g, '$1');
    }

    // If amount ensure does not exceed maximum
    if (amount) {
      const value = parseFloat(e.target.value) || 0;
      if (value > amount) {
        e.target.value = amount;
      }
    }
  };

  return (
    <div>
      <div className="label-wrapper">
        <label className="input-label">{label}</label>
        {amount && (
          <div
            className="helper-text"
            style={{ marginBottom: !label && "8px"}}
          >
            Available amount:<span> {amount}</span> {currency}
          </div>
        )}
      </div>
      <input {...props} className={`${className ? className : ""} input`} onInput={handleInput}/>
    </div>
  );
};

export default Input;
